import { SearchItem } from '@yiluhub/yilu-amp-types';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { paramConverters, yiluTracking } from 'utils';

import routes from 'router/routes';

import { PaymentInformationProps } from 'components/PaymentInformation';

import { getLoungeStripeLabel, getProductDetails } from 'modules/lounges/utils/getProductDetails';

import { LoungePaymentInputPageQueryParams } from '../../../utils/query-params';
import { getActualLoungePrice } from './index';

const useLoungePaymentInformationFormProps = (
  currentLounge: SearchItem | undefined,
  paymentFormRef: React.RefObject<HTMLFormElement>,
  loungePaymentInputPageQueryParams: LoungePaymentInputPageQueryParams,
  pricingOption: string,
) => {
  const navigate = useNavigate();
  const paymentInformationFormProps = useMemo(() => {
    if (!currentLounge) {
      return null;
    }

    const { providerId, price, currency, allowCreditCardPayment } =
      getProductDetails(currentLounge);

    const actualPrice = getActualLoungePrice(currentLounge, pricingOption);

    const _props: PaymentInformationProps = {
      ref: paymentFormRef,
      amount: {
        price: actualPrice?.price! || price,
        currency,
      },
      stripeMerchantLabel: getLoungeStripeLabel(),
      productTrackingId: 'lounge',
      serviceProviderId: providerId,
      bookingIntentId: loungePaymentInputPageQueryParams.bookingIntentId,
      userId: loungePaymentInputPageQueryParams.userId as string,
      touchPointId: loungePaymentInputPageQueryParams.touchpoint as string,
      decisionId: loungePaymentInputPageQueryParams.decisionID_PPFI as string,
      shoppingCartId: loungePaymentInputPageQueryParams.shoppingCartId!,
      allowCreditCardPayment,
      onPayment: (response) => {
        const bookingConfirmationPageQueryParams = {
          bookingId: response.id,
        };

        yiluTracking.sendPaymentSuccessfulEvent(loungePaymentInputPageQueryParams.bookingIntentId);

        navigate({
          pathname: routes.LOUNGES_BCP,
          search: paramConverters.getURLSearchQuery(bookingConfirmationPageQueryParams),
        });
      },
      onError(error: Error) {
        throw error;
      },
    };
    return _props;
  }, [currentLounge, loungePaymentInputPageQueryParams, paymentFormRef, navigate, pricingOption]);

  return paymentInformationFormProps;
};

export default useLoungePaymentInformationFormProps;
